/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerDropCodeService = {

  async getDefault(params) {
    const requestScreenData = {
      url: "api/DropCode",
      top: "1",
      filter: `IsDefault eq 'Y' and Inactive eq 'N'`,
    };

    if (params) {
      if (params.select) requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerDropCodeService };
